import { useState, useEffect } from "react"
import { useQueryGet } from "../../../../../typed-client/hooks/use-query-get"
import { Page } from "../../../../../-components/Page"
import { useGetNewReminderMenuItemProps } from "@components/useGetNewReminderMenuItemProps"
import { useGetReminderListMenuItemProps } from "@components/useGetReminderListMenuItemProps"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { ColumnLayout } from "../../../-components/column-layout"
import { Text } from "@mantine/core"
import { useRouter } from "@tanstack/react-router"
import { ContractTrackingCard } from "@/components/contracts/ContractTrackingCard"
import { ContractConfirmationsCard } from "@/components/contracts/ContractConfirmationsCard"
import { ContractDatesCard } from "@/components/contracts/ContractDatesCard"
import { ContractFieldsCard } from "@/components/contracts/ContractFieldsCard"
import { ContractEngagementsCard } from "@/components/contracts/ContractEngagementsCard"
import { ContractDetailsCard } from "@/components/contracts/ContractDetailsCard"
import { PersonName } from "@components/PersonName"
import { ReminderPageWrapper } from "@/routes/-components/reminders/ReminderPageWrapper"

export function ContractDetailsPage({ contractId }: { contractId: number }) {
  const searchParams = new URLSearchParams(window.location.search)
  const detailOpened = searchParams.get("reminderDetailOpened") === "true"
  const reminderId = searchParams.get("reminderId")
  const [detailModalOpen, setDetailModalOpen] = useState(detailOpened)

  const { data: selectedReminder, isLoading: loadingReminder } = useQueryGet(
    "/api/Reminder/GetReminderById",
    reminderId ? { reminderId: Number(reminderId) } : ({} as any),
    {
      enabled: !!detailOpened && !!reminderId,
    }
  )

  useEffect(() => {
    setDetailModalOpen(detailOpened)
  }, [detailOpened])
  const { data: contract } = useSuspenseQueryGet(
    "/api/Contracts/GetContractDetails",
    { id: contractId }
  )

  const productionActivities = contract.engagements.flatMap((engagement) => ({
    productionTitle: engagement.production,
    contractDates: engagement.contractDates,
  }))

  const router = useRouter()

  React.useEffect(() => {
    router.invalidate()
  }, [contract])

  const { menuItem: newReminderMenuItemProps, modal: reminderInputModal } =
    useGetNewReminderMenuItemProps()
  const { menuItem: reminderListMenuItemProps, modal: reminderListModal } =
    useGetReminderListMenuItemProps()

  return (
    <ReminderPageWrapper
      reminderId={reminderId}
      detailOpened={detailModalOpen}
      onClose={() => {
        setDetailModalOpen(false)
        const params = new URLSearchParams(window.location.search)
        params.delete("reminderDetailOpened")
        params.delete("reminderId")
        window.history.replaceState(null, "", `?${params.toString()}`)
      }}
    >
      <Page
        crumbOverride={() => (
          <Text fz="xl" fw={"bold"}>
            {contract.contractTypeName}{" "}
            <PersonName personId={contract.personId} />
          </Text>
        )}
        dottedMenuProps={{
          items: [newReminderMenuItemProps, reminderListMenuItemProps],
        }}
      >
        <ColumnLayout>
          <ContractDetailsCard contract={contract} />
          <ContractEngagementsCard engagements={contract.engagements} />
          <ContractFieldsCard fieldsGrouped={contract.contractFields} />
          {productionActivities.length > 0 &&
            productionActivities.some(
              (productionActivitie) =>
                productionActivitie.contractDates.length > 0
            ) && <ContractDatesCard data={productionActivities} />}
          <ContractConfirmationsCard confirmations={contract.confirmations} />
          <ContractTrackingCard
            contractTrackings={contract.contractTrackings}
          />
        </ColumnLayout>
        {reminderInputModal}
        {reminderListModal}
      </Page>
    </ReminderPageWrapper>
  )
}
